import {
  RemotePushNotification,
  RemoteSchedulePushNotification,
} from 'data/usecases';
import {
  PushNotificationUseCaseInterface,
  SchedulePushNotificationUseCaseInterface,
} from 'domain/usecases';
import {
  makeApiUrlPushNotification,
  makeApiUrlSchedulePushNotification,
} from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makePushNotification = (): PushNotificationUseCaseInterface =>
  new RemotePushNotification(
    makeApiUrlPushNotification(),
    makeAxiosHttpClient(),
  );

export const makeSchedulePushNotification =
  (): SchedulePushNotificationUseCaseInterface =>
    new RemoteSchedulePushNotification(
      makeApiUrlSchedulePushNotification(),
      makeAxiosHttpClient(),
    );
